import React, { useState, useEffect } from "react";
import axios from "axios"; //Libreria necesaria npm i axios
import { useNavigate } from "react-router-dom"; // Importa el hook useHistory
import "./CreateClass.css";
import { routeCreateClase, routeFindUserByRol } from "./constants";

export const CreateClass = () => {
  const [matricula_clase, setMatriculaClase] = useState("");
  const [nombre_clase, setNombreClase] = useState("");
  const [descripcion, setDescription] = useState("");
  const [matricula_maestro, setMatriculaMaestro] = useState("");
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");

  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [maestros, setMaestros] = useState([]);

  useEffect(() => {
    const fetchMaestros = async () => {
      try {
        const resp = await axios.get(routeFindUserByRol, {
          params: { role: "Maestro" }, // <-- aquí era rol, no role
        });
        // Si tu API envía {success, data: [...]}, toma data; si no, toma el array directo
        const lista = resp.data?.data ?? resp.data ?? [];
        setMaestros(Array.isArray(lista) ? lista : []);
      } catch (err) {
        console.error("❌ Error al cargar maestros:", err);
        setMaestros([]);
      }
    };
    fetchMaestros();
  }, []);

  const handleSubmitClass = async (e) => {
    e.preventDefault();

    console.log("📌 Enviando datos para crear clase:", {
      nombre_clase,
      descripcion,
      matricula_maestro,
      matricula_clase,
    });

    // Limpia error visible en UI
    setError("");

    try {
      const response = await axios.post(routeCreateClase, {
        nombre_clase,
        descripcion,
        matricula_maestro,
        matricula_clase,
        fecha_inicio: fechaInicio,
        fecha_fin: fechaFin,
      });

      console.log("🔎 Respuesta completa de la API:", response);

      const { status, data } = response;

      // Normaliza a string para detección por texto
      const dataStr = typeof data === "string" ? data : JSON.stringify(data);

      // Criterios de éxito (cualquiera de estos):
      // - data.success === true
      // - existe data.id_clase
      // - el backend devolvió un string que sugiere éxito
      const success =
        (data && typeof data === "object" && data.success === true) ||
        (data && typeof data === "object" && data.id_clase) ||
        (typeof data === "string" &&
          /clase\s+(creada|registrad[oa])/i.test(dataStr));

      if ((status === 200 || status === 201) && success) {
        console.log("✅ Clase creada con éxito", data);
        alert(`✅ Clase creada con éxito`);
      } else {
        // ⚠️ Respuesta 200 pero contenido no indica éxito → tratar como error
        console.warn("⚠️ La API respondió, pero no parece éxito:", {
          status,
          data,
        });
        const msg =
          (data && typeof data === "object" && (data.message || data.error)) ||
          (typeof data === "string"
            ? data
            : "Respuesta inesperada del servidor.");
        setError(`❌ No se pudo crear la clase: ${msg}`);
        alert(`❌ No se pudo crear la clase: ${msg}`);
      }
    } catch (error) {
      console.error("❌ Error al crear clase:", error);

      let msg = "Error desconocido";
      let detalle = null;

      if (error.response) {
        // Error con respuesta del servidor
        const d = error.response.data;
        detalle = d;
        msg =
          (d && typeof d === "object" && (d.message || d.error)) ||
          (typeof d === "string" ? d : `HTTP ${error.response.status}`);
      } else if (error.request) {
        msg =
          "No hubo respuesta del servidor. Verifica tu conexión o el backend.";
      } else {
        msg = error.message;
      }

      // Si el backend mapea errno/sqlstate/hint, muéstralo en consola para depurar
      if (detalle && typeof detalle === "object") {
        console.log("🧩 Detalles del servidor:", {
          errno: detalle.errno,
          sqlstate: detalle.sqlstate,
          hint: detalle.hint,
        });
      }

      setError(`❌ No se pudo crear la clase: ${msg}`);
      alert(`❌ No se pudo crear la clase: ${msg}`);
    }
  };

  const handleRegresarButton = () => {
    navigate("/admin-home");
  };
  return (
    <div className="full-page">
      <div className="container1">
        <form onSubmit={handleSubmitClass}>
          <div className="title">
            <h1>Crear Clase</h1>
          </div>
          <div className="class-name">
            <label>Nombre de la clase</label>
            <div>
              <input
                type="text"
                value={nombre_clase}
                onChange={(e) => setNombreClase(e.target.value)}
              ></input>
            </div>
          </div>
          <div className="class-description">
            <label>Descripción de la clase</label>
            <div>
              <input
                type="text"
                value={descripcion}
                onChange={(e) => setDescription(e.target.value)}
              ></input>
            </div>
          </div>
          <div className="teacher-id">
            <label>Matrícula Maestro</label>
            <div>
              <select
                value={matricula_maestro}
                onChange={(e) => setMatriculaMaestro(e.target.value)}
              >
                <option value="">-- Selecciona un maestro --</option>
                {maestros.map((m) => (
                  <option key={m.id} value={m.matricula}>
                    {m.matricula} - {m.nombre} {m.apellido}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="class-id">
            <label>Crear Matricula de la clase</label>
            <div>
              <input
                type="text"
                value={matricula_clase}
                onChange={(e) => setMatriculaClase(e.target.value)}
              ></input>
            </div>
          </div>
          <div className="class-dates">
            <label>Fecha de inicio</label>
            <div>
              <input
                type="date"
                value={fechaInicio}
                onChange={(e) => setFechaInicio(e.target.value)}
              />
            </div>

            <label>Fecha de fin</label>
            <div>
              <input
                type="date"
                value={fechaFin}
                onChange={(e) => setFechaFin(e.target.value)}
              />
            </div>
          </div>

          <div className="submit">
            <button type="submit">Crear Clase</button>
            {error && <div>{error}</div>}
          </div>
          <div className="underline2"></div>
        </form>
        <div className="return-home">
          <span onClick={handleRegresarButton}>Regresar Home</span>
        </div>
      </div>
    </div>
  );
};
